import React from 'react';
import { PlusOutlined, ReloadOutlined } from '@ant-design/icons';

interface PanelButtonsProps {
  onRefresh: () => void;
  onCreate: () => void;
}

/**
 * 面板按钮配置
 */
export const getPanelButtons = ({
  onRefresh,
  onCreate,
}: PanelButtonsProps) => [
  {
    key: 'refresh',
    icon: <ReloadOutlined />,
    type: 'text' as const,
    onClick: onRefresh,
    title: '刷新',
    showTextOnHover: true,
  },
  {
    key: 'create',
    icon: <PlusOutlined />,
    type: 'primary' as const,
    onClick: onCreate,
    text: '创建资源',
  },
];
